import Vue from 'vue';
import VueI18n from 'vue-i18n';

import elementRu from 'element-ui/lib/locale/lang/ru-RU';
import elementUa from 'element-ui/lib/locale/lang/ua';
import elementEn from 'element-ui/lib/locale/lang/en';

import generalRu from './ru/general';
import signinRu from './ru/signin';
import navigationRu from './ru/navigation';
import headersRu from "./ru/tableHeaders";
import formElemetsRu from "./ru/formElements";
import tasksRu from "./ru/tasks";
import linkingRu from "./ru/linking";
import cronRu from './ru/cron';
import referenceGridRu from './ru/referenceGrid';
import viewsConfigRu from './ru/viewsConfig';
import viewsCommonRu from './ru/viewsCommon';
import viewsCronRu from './ru/viewsCron';
import viewsMiscRu from './ru/viewsMisc';
import viewsReferenceRu from './ru/viewsReference';
import viewsRunTaskRu from './ru/viewsRuntask';

import generalUa from './ua/general';
import signinUa from './ua/signin';
import navigationUa from './ua/navigation';
import headersUa from "./ua/tableHeaders";
import formElemetsUa from "./ua/formElements";
import tasksUa from "./ua/tasks";
import linkingUa from "./ua/linking";
import cronUa from './ua/cron';
import referenceGridUa from './ua/referenceGrid';
import viewsConfigUa from './ua/viewsConfig';
import viewsCommonUa from './ua/viewsCommon';
import viewsCronUa from './ua/viewsCron';
import viewsMiscUa from './ua/viewsMisc';
import viewsReferenceUa from './ua/viewsReference';
import viewsRunTaskUa from './ua/viewsRuntask';

import generalEn from './en/general';
import signinEn from './en/signin';
import navigationEn from './en/navigation';
import headersEn from "./en/tableHeaders";
import formElemetsEn from "./en/formElements";
import tasksEn from "./en/tasks";
import linkingEn from "./en/linking";
import cronEn from './en/cron';
import referenceGridEn from './en/referenceGrid';
import viewsConfigEn from './en/viewsConfig';
import viewsCommonEn from './en/viewsCommon';
import viewsCronEn from './en/viewsCron';
import viewsMiscEn from './en/viewsMisc';
import viewsReferenceEn from './en/viewsReference';
import viewsRunTaskEn from './en/viewsRuntask';

Vue.use(VueI18n);

const messages = {
	ru: {
		...elementRu,
		...generalRu,
		...signinRu,
		...navigationRu,
		...headersRu,
		...formElemetsRu,
		...tasksRu,
		...linkingRu,
		...cronRu,
		...referenceGridRu,
		...viewsConfigRu,
		...viewsCommonRu,
		...viewsCronRu,
		...viewsMiscRu,
		...viewsReferenceRu,
		...viewsRunTaskRu,
	},
	ua: {
		...elementUa,
		...generalUa,
		...signinUa,
		...navigationUa,
		...headersUa,
		...formElemetsUa,
		...tasksUa,
		...linkingUa,
		...cronUa,
		...referenceGridUa,
		...viewsConfigUa,
		...viewsCommonUa,
		...viewsCronUa,
		...viewsMiscUa,
		...viewsReferenceUa,
		...viewsRunTaskUa,
	},
	en: {
		...elementEn,
		...generalEn,
		...signinEn,
		...navigationEn,
		...headersEn,
		...formElemetsEn,
		...tasksEn,
		...linkingEn,
		...cronEn,
		...referenceGridEn,
		...viewsConfigEn,
		...viewsCommonEn,
		...viewsCronEn,
		...viewsMiscEn,
		...viewsReferenceEn,
		...viewsRunTaskEn,
	}
};

export default new VueI18n({
	locale: process.env.VUE_APP_I18N_LOCALE || 'ru',
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ru',
	messages
});
